import { useState } from 'react';
import { faqData } from '@/mocks/siteConfig';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-500 text-base">
            Everything you need to know about Superbuy Spreadsheet resources
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-100 border border-background-200/40 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
              >
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${
                  openIndex === i ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === i ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 md:px-6 pb-5 md:pb-6 text-foreground-600 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}